import { Button } from 'components/Button'
import MultiSelector from 'common/MultiSelector/MultiSelector'
import SettingsStyles from 'components/Settings/SettingsModal.module.scss'
import { Text } from 'blaze-ui/Text/Text';
import { Heading } from 'blaze-ui/Heading/Heading';

interface Props {
  options: ({ value: string | undefined; label: string | undefined } | undefined)[]
  selected: ({ value: string | undefined; label: string | undefined } | undefined)[]
  dirty: boolean
  handleSelect: (domains: any) => void
  handleSave: () => void
}

const AllowedDomains = ({ options, selected, dirty, handleSelect, handleSave }: Props) => {
  return (
    <div className={SettingsStyles.settingsSection}>
      <div className={SettingsStyles.settingsOption}>
        <Heading level={5}>Allowed domains</Heading>
        <div className={SettingsStyles.helpText}>
          <Text variant="secondary" color="var(--dark-60)">
            Allow your teammates to find this workspace when they sign up or log in with an email address from one of
            these domains. New domains are added as admins join this workspace.
          </Text>
        </div>
        <div className={SettingsStyles.inputRow}>
          <MultiSelector
            options={options}
            selected={selected}
            setSelected={handleSelect}
            noOptionsMessage="Only domains of an existing member can be added to a workspace"
            placeholder="Enter the domain of an existing member..."
          />
        </div>
        <Button className={SettingsStyles.saveButton} type="submit" isDisabled={!dirty} onPress={handleSave}>
          Save
        </Button>
      </div>
    </div>
  )
}
export default AllowedDomains
